import React from 'react';
import { Link } from 'react-router-dom';
import { Edit, FileText, Delete, X, Copy, RefreshCw, Eye } from 'react-feather';
import './CrudButton.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

export const EditButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.modify')}</span>
    <Link name="edit" to={props.entityRoute + '/edit/' + props.resource.id}><Edit size={18} /></Link>
  </span>
);

EditButton.contextTypes = {
  locale: PropTypes.string,
};

export const ViewButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.view')}</span>
    <Link to={props.entityRoute + '/view/' + props.resource.id}><FileText size={18} /></Link>
  </span>
);

ViewButton.contextTypes = {
  locale: PropTypes.string,
};

export const CopyButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.duplicate')}</span>
    <Link to={props.entityRoute + '/' + props.resource.id}><Copy size={18} /></Link>
  </span>
);

CopyButton.contextTypes = {
  locale: PropTypes.string,
};

export const DeleteButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.delete')}</span>
    <a name="delete" onClick={() => props.handleRemove(props.resource.id)}><Delete size={18} /></a>
  </span>
);

DeleteButton.contextTypes = {
  locale: PropTypes.string,
};

export const DeleteAssociationButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.delete')}</span>
    <a name="delete-association" onClick={() => props.handleRemove(props.parentResource, props.resource, props.updateResults)}><X size={18} /></a>
  </span>
);

DeleteAssociationButton.contextTypes = {
  locale: PropTypes.string,
};

export const ResendButton = (props, context) => (
  <span className="CrudButton">
    <span className="tooltip">{getLabel(context.locale, 'general.resend')}</span>
    <a name="resend" onClick={() => props.handleResend(props.resource.id)}><RefreshCw size={18} /></a>
    {/* <a name="resend" to={props.entityRoute + 's/resend/' + props.resource.id}><RefreshCw size={18} /></a> */}
  </span>
);

export const AcknowledgeButton = (props, context) => {
  if(props.resource.lastApprovedSafetyDataSheet != null){
    return (
      <span className="CrudButton">
        <span className="tooltip">{getLabel(context.locale, 'general.acknowlegmentSDShandleAdd.title')}</span>
        <a name="delete" onClick={() => props.handleAdd(props.resource.id)}>
            <Eye size={18} />
        </a>
      </span>
    );
  }else{
    return (
      <span className="CrudButton">
      </span>
    );
  }
};





// WEBPACK FOOTER //
// ./src/main/components/output/CrudButton.js